export default "__VITE_ASSET__DIMYX2Xe__"